import { AUTH_SESSION_PROBE_KEY } from '@/config/constants';
import { storage } from '@/utils/storage';

import { getRefreshToken } from './token';

/**
 * Đánh dấu đã từng có phiên đăng nhập trên trình duyệt này (để bootstrap có thể thử refresh cookie HttpOnly).
 */
export function setSessionProbeFlag(): void {
  storage.set(AUTH_SESSION_PROBE_KEY, true);
}

export function clearSessionProbeFlag(): void {
  storage.remove(AUTH_SESSION_PROBE_KEY);
}

function hasStoredSessionProbe(): boolean {
  return storage.get<boolean>(AUTH_SESSION_PROBE_KEY) === true;
}

/**
 * Có nên gọi `POST /api/auth/refresh` khi không còn access token: có refresh trong storage hoặc đã từng đăng nhập (probe).
 */
export function shouldAttemptSilentSessionRestore(): boolean {
  return Boolean(getRefreshToken() || hasStoredSessionProbe());
}
